export default {

  state:{
    clients:['iphone','aphone','ipad','apad']
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/mvir.js